import { render, staticRenderFns } from "./create-or-edit-data-auth.vue?vue&type=template&id=1878f862&scoped=true&"
import script from "./create-or-edit-data-auth.vue?vue&type=script&lang=js&"
export * from "./create-or-edit-data-auth.vue?vue&type=script&lang=js&"
import style0 from "./create-or-edit-data-auth.vue?vue&type=style&index=0&id=1878f862&scoped=true&lang=less&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1878f862",
  null
  
)

export default component.exports